<div class="products-grid products-grid-related" *ngIf="order">
    <div class="products-grid__heading mt-3">
        <h2>Related Products</h2>
    </div>
    <div class="products-grid__content">
        <div *ngFor="let product of products" class="products-grid__item px-3">
            <app-product-grid-item [order]="order" [product]="product"></app-product-grid-item>
        </div>
    </div>
</div>
